<template>
  <form ref="uploadForm">
    <input @change="_onSelected" data-test-path="upload-file-input" type="file" ref="fileInput" class="p-0 m-0" style="display:block; width: 0px; height: 0px; overflow: hidden;"/>
    <b-container class="p-0">
      <b-row no-gutters v-if="!showProgressBar" >
        <b-col cols="auto">
          <b-button :disabled="readOnly" v-if="showUploadButton" class="mr-1" variant="plm-toolbar-secondary" type="button" @click="_triggerFileSelection">
            <font-awesome-icon icon="file-upload"/>
            Upload file
          </b-button>
        </b-col>

        <b-col>
          <div class="form-control grey-label"
               v-if="readOnly"
          >
          </div>
          <b-form-input v-else v-model="fileName" :class="isValid ? '':'is-invalid'" readonly style="background-color: white" placeholder="" ></b-form-input>
          <div class="invalid-feedback">{{invalidFeedback}} </div>
        </b-col>
        <b-col cols="auto" align-self="center" class="p-0 m-0">
          <b-button ref="xyz" v-if="showResetButton" class="ml-1" variant="plm-danger" type="button" @click="reset">
            <font-awesome-icon icon="window-close"/>
          </b-button>
          <h2 class="align-middle mb-0 ml-1 text-success" v-if="showDoneIcon">
            <font-awesome-icon style="margin-bottom:1px" :icon="['far', 'check-circle']"/>
          </h2>
        </b-col>

      </b-row>
      <b-row no-gutters v-if="showProgressBar">
        <b-col style="min-width: 100px; padding-top: 10px;">
          <b-progress  :value="progress" variant="success" striped :animated="progressAnimated"></b-progress>
        </b-col>
      </b-row>

    </b-container>
  </form>
</template>

<script>

export default {
  name: "FileUpload",
  mounted() {

  },
  methods: {
    setError(err) {
      this.reset();
      this.isValid = false;
      this.invalidFeedback = err;
    },

    reset() {
      this.showProgressBar = false;
      this.showUploadButton = true;
      this.showResetButton = false;
      this.showDoneIcon = false;
      //this.fileName = "";
      this.file = null;
      this.$refs.uploadForm.reset();
      this.isValid = true;
    },

    setProgress(percent) {
      this.isValid = true;
      this.showProgressBar = true;
      this.progress = percent;
    },

    setDone() {
      this.showProgressBar = false;
      this.showUploadButton = this.allowNewUpload;
      this.showResetButton = false;
      this.showDoneIcon = true;
      this.progress = 0;
    },

    getFile() {
      return this.file;
    },

    getFileName() {
      return this.fileName;
    },

    _triggerFileSelection() {
      this.reset();
      this.$refs['fileInput'].click();
    },

    _onSelected() {
      if (!this.$refs['fileInput'].files || !this.$refs['fileInput'].files[0]) {
        this.reset();
        return;
      }

      this.file = this.$refs['fileInput'].files[0];
      this.fileName = this.file.name;

      const maxFileSize = 250 * 1024 * 1024;

      const forbiddenCharacters = /[\\/:*?"<>||]/;

      if (this.file.size > maxFileSize) {
        this.setError($tr("maximum.file.size.error", "File exceeds maximum size of 250 MB."));
        return;
      }

      const forbiddenCharactersDisplay = "\\ / : * ? \" < > | ";
      const message = $tr("illegal.characters.file.name.error.upload", "The file name contains illegal characters. Illegal characters: ");
      const finalMessage = message + forbiddenCharactersDisplay;
      if (forbiddenCharacters.test(this.fileName)) {
        this.setError(finalMessage);
        return;
      }

      this.isValid = true;
      this.$emit("file-selected", this.file);
      this.showResetButton = true;
    }
  },
  props: {
    fileSelected: Function,
    readOnly: {type: Boolean, default: false},

    allowNewUpload: {type: Boolean, default: true}
  },
  data: function () {
    return {
      temp: true,
      progress: 0,
      fileName: "",
      file: null,
      showProgressBar: false,
      progressAnimated: true,
      showUploadButton: true,
      showResetButton: false,
      showDoneIcon: false,
      invalidFeedback: "",
      isValid: true,
    }
  }
}
</script>
